import * as React from "react";
import CarouselECS from "./carousel/CarouselECS";
import { Timeline, Tween } from "react-gsap";
import { Controller, Scene } from "react-scrollmagic";
import styled from "styled-components";
import { MAX_WIDTH, MAX_WIDTH_STR } from "../model/Const";
import { OrientationContext } from "../provider/OrientationProvider";
import { IUADevice, userAgentInfo } from "../model/UserAgentInfo";
import { CSSProperties } from "react";

const AskHeader = styled.div`
	font-size: 4vw;
	padding: 20px 0 0 0;
	position: relative;
	font-family: nicomoji;
	font-weight: normal;
`;

export default function Ask() {
	// useContext
	const context = React.useContext( OrientationContext );

	// 最大幅を設定するスタイル（PCの場合のみ設定）
	const maxWidthStyle = React.useMemo( () => {
		// 幅が最大幅より大きく、PCだったら最大幅を指定
		if ( window.innerWidth > MAX_WIDTH && userAgentInfo.device === IUADevice.pc ) {
			return {
				parentDiv: {
					maxWidth: MAX_WIDTH_STR,
					margin: "auto"
				} as CSSProperties,
				askHeader: {
					fontSize: "3rem"
				} as CSSProperties,
				carouselMaxClassName: " max",
			}
		}

		return {
			parentDiv: undefined,
			askHeader: undefined,
			carouselMaxClassName: "",
		};
	}, [context.resize] );

	return (
		<Controller>
			{/*画像*/}
			<Scene
				triggerHook={0.9}
				duration={"80%"}
				offset={50}
			>
				{( progress: any ) => (
					<div style={{
						width: "100%",
						backgroundColor: "white",
						position: "relative",
						padding: "0 0 5vh 0"
					}}>
						<div style={{
							...maxWidthStyle.parentDiv,
							textAlign: "center",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							flexDirection: "column",
						}}>

							<Timeline totalProgress={progress} paused>
								<Tween
									from={{
										opacity: 0
									}}
									to={{
										opacity: 1
									}}
								>
									<h1 style={{
										width: "100%",
										textAlign: "center"
									}}>
										<AskHeader style={{
											...maxWidthStyle.askHeader
										}}>本当にキレイな電子コミックってみたことありますか？</AskHeader>
									</h1>
								</Tween>

								<Tween
									from={{
										opacity: 0
									}}
									to={{
										opacity: 1
									}}
								>
									<div style={{
										height: "90%",
										width: "100%"
									}}>
										<CarouselECS
											centerPadding={window.innerWidth * 0.1 + "px"}
											carouselMaxClassName={maxWidthStyle.carouselMaxClassName}
										/>
									</div>
								</Tween>
							</Timeline>
						</div>
					</div>
				)}
			</Scene>

		</Controller>
	);
};